<template>
  <div class="box-filtres">
    <table>
      <tbody>
        <tr>
          <td width="150px">
            <input id="fechainicio" placeholder="Fecha inicio" datatype="fecha"
              type="text" class="form-control" autocomplete="off">
          </td>

          <td width="150px">
            <input id="fechafin" placeholder="Fecha final" datatype="fecha"
              type="text" class="form-control" autocomplete="off">
          </td>

          <td width="150px">
            <select :value="tipo" class="form-control"
              @change="$emit('tipo', $event.target.value)">
              <option value="1">ACTIVAS</option>
              <option value="2">ANULADAS</option>
              <option value="3">TODAS</option>
              <option value="4">NC PARCIALES</option>
            </select>
          </td>

          <td>
            <button
              type="button"
              class="btn btn-warning"
              :disabled="loading || loadingExport"
              @click="$emit('consultar')">
              Consultar
            </button>
          </td>

          <td>
            <button
              type="button"
              class="btn btn-success"
              :disabled="loading || loadingExport"
              @click="$emit('exportar')">

              <i v-if="loadingExport" class="fa fa-spinner fa-spin"></i>

              {{ loadingExport ? "Generando..." : "Exportar Excel" }}
            </button>
          </td>

          <td>
            <div v-if="loading || loadingExport">
              <img src="dist/img/kubber-loading.gif" style="width:30px">
            </div>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    tipo: String,
    loading: Boolean,
    loadingExport: Boolean
  }
};
</script>